"use client";

import Link from "next/link";
import { useSelectedLayoutSegment } from "next/navigation";
interface Props {
  href: string;
  children: React.ReactNode;
}
export function NavLink({
  href,
  children
}: Props) {
  const segment = useSelectedLayoutSegment();
  const active = href === `/${segment}`;
  return <Link className={active ? "font-bold text-[#152B6F]" : "text-[#152B6F]"} href={href} data-sentry-element="Link" data-sentry-component="NavLink" data-sentry-source-file="NavLink.tsx">
      {children}
    </Link>;
}